import { httpService, WebRequestFactory, fromPascalToCamel, fromStatusCodeToGenericError } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";
import { ITemporaryAccessAdmin } from "../interfaces/setting-categories/ITemporaryAccessAdmin";
import { BackendTemporaryAccessAdminsResponse } from "../types/BackendTemporaryAccessAdminsResponse";

export const getTemporaryAccessAdmins = WebRequestFactory.createGet<Array<ITemporaryAccessAdmin>>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: fromPascalToCamel<BackendTemporaryAccessAdminsResponse, Array<ITemporaryAccessAdmin>>,
    url: () => apiConfig.temporaryAccessAdmins()
});
